import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4d15d94e = () => interopDefault(import('../../../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _400b8862 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _1e04a14e = () => interopDefault(import('../../../pages/assess/index.vue' /* webpackChunkName: "pages/assess/index" */))
const _9790fc24 = () => interopDefault(import('../../../pages/pro/index.vue' /* webpackChunkName: "pages/pro/index" */))
const _5502af01 = () => interopDefault(import('../../../pages/satisfaction/index.vue' /* webpackChunkName: "pages/satisfaction/index" */))
const _155a7d0a = () => interopDefault(import('../../../pages/senior_user/index.vue' /* webpackChunkName: "pages/senior_user/index" */))
const _460588f6 = () => interopDefault(import('../../../pages/service/index.vue' /* webpackChunkName: "pages/service/index" */))
const _f11e3062 = () => interopDefault(import('../../../pages/survey/index.vue' /* webpackChunkName: "pages/survey/index" */))
const _26fdda1e = () => interopDefault(import('../../../pages/about/contentrule.vue' /* webpackChunkName: "pages/about/contentrule" */))
const _c1a187d0 = () => interopDefault(import('../../../pages/about/contentrulecontent.vue' /* webpackChunkName: "pages/about/contentrulecontent" */))
const _50254a46 = () => interopDefault(import('../../../pages/about/developer.vue' /* webpackChunkName: "pages/about/developer" */))
const _61284b62 = () => interopDefault(import('../../../pages/about/disclaimer.vue' /* webpackChunkName: "pages/about/disclaimer" */))
const _692b4374 = () => interopDefault(import('../../../pages/about/drawrule.vue' /* webpackChunkName: "pages/about/drawrule" */))
const _3a5007a6 = () => interopDefault(import('../../../pages/about/entauthagree.vue' /* webpackChunkName: "pages/about/entauthagree" */))
const _60fe01fe = () => interopDefault(import('../../../pages/about/entauthpolicy.vue' /* webpackChunkName: "pages/about/entauthpolicy" */))
const _47982c00 = () => interopDefault(import('../../../pages/about/enveloperule.vue' /* webpackChunkName: "pages/about/enveloperule" */))
const _f0030d78 = () => interopDefault(import('../../../pages/about/partner.vue' /* webpackChunkName: "pages/about/partner" */))
const _224e86f0 = () => interopDefault(import('../../../pages/about/ystk/index.vue' /* webpackChunkName: "pages/about/ystk/index" */))
const _492ef830 = () => interopDefault(import('../../../pages/about/zxzx.vue' /* webpackChunkName: "pages/about/zxzx" */))
const _f9388452 = () => interopDefault(import('../../../pages/about/ystk/app.vue' /* webpackChunkName: "pages/about/ystk/app" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _4d15d94e,
    name: "about"
  }, {
    path: "/app",
    component: _400b8862,
    name: "app"
  }, {
    path: "/assess",
    component: _1e04a14e,
    name: "assess"
  }, {
    path: "/pro",
    component: _9790fc24,
    name: "pro"
  }, {
    path: "/satisfaction",
    component: _5502af01,
    name: "satisfaction"
  }, {
    path: "/senior_user",
    component: _155a7d0a,
    name: "senior_user"
  }, {
    path: "/service",
    component: _460588f6,
    name: "service"
  }, {
    path: "/survey",
    component: _f11e3062,
    name: "survey"
  }, {
    path: "/about/contentrule",
    component: _26fdda1e,
    name: "about-contentrule"
  }, {
    path: "/about/contentrulecontent",
    component: _c1a187d0,
    name: "about-contentrulecontent"
  }, {
    path: "/about/developer",
    component: _50254a46,
    name: "about-developer"
  }, {
    path: "/about/disclaimer",
    component: _61284b62,
    name: "about-disclaimer"
  }, {
    path: "/about/drawrule",
    component: _692b4374,
    name: "about-drawrule"
  }, {
    path: "/about/entauthagree",
    component: _3a5007a6,
    name: "about-entauthagree"
  }, {
    path: "/about/entauthpolicy",
    component: _60fe01fe,
    name: "about-entauthpolicy"
  }, {
    path: "/about/enveloperule",
    component: _47982c00,
    name: "about-enveloperule"
  }, {
    path: "/about/partner",
    component: _f0030d78,
    name: "about-partner"
  }, {
    path: "/about/ystk",
    component: _224e86f0,
    name: "about-ystk"
  }, {
    path: "/about/zxzx",
    component: _492ef830,
    name: "about-zxzx"
  }, {
    path: "/about/ystk/app",
    component: _f9388452,
    name: "about-ystk-app"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
